<h1>Playground</h1>

<h2>Multi File Upload</h2>
<black-multi-file-upload
  selectedCourseId="65d4d7893476deeabe5b2e92"
></black-multi-file-upload>
  
<h2>Image Upload</h2>

<black-image-upload
  [uploadUrl]="uploadUrl"
  (imageUploaded)="onImageUploaded($event)"
></black-image-upload>

<button class="daisy-btn" (click)="addToast()">Click me</button>


